import { render, staticRenderFns } from "./CounselorByGender.vue?vue&type=template&id=44cfd144&"
import script from "./CounselorByGender.vue?vue&type=script&lang=js&"
export * from "./CounselorByGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports